import { z, zCoercedBoolean } from '@harvestiq/zod';
import { zDecimalRequired, zIsoDate } from '@harvestiq/zod';
import {
  CampaignCoverageTier,
  LrpCampaignPdfColumns,
  RmaLrpCommodityCodes,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';

export const getLrpQuoteAndPdfParamsSchema = z.object({
  coverageTier: z.nativeEnum(CampaignCoverageTier).nullable().optional(),
  marketingMonths: z.array(z.coerce.number()).optional(), // This name is misleading, it reflects what it is doing but it's the same name used for LGM coverage marketing months
  commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
  typeCode: z.nativeEnum(RmaLrpTypeCodes),
  targetSalesEffectiveDate: zIsoDate().nullable().optional(),
  endDate: zIsoDate().nullable().optional(),
  targetWeight: zDecimalRequired(),
  numberOfHead: z.coerce.number().int().min(1),
  isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
  isVeteranFarmerRancher: zCoercedBoolean().optional(),
  beginningFarmerRancherCropYearCount: z.coerce
    .number()
    .int()
    .nullable()
    .optional(),
  quoteColumns: z.array(z.nativeEnum(LrpCampaignPdfColumns)).optional(),
  logoUrl: z.string().url(),
  orgId: z.string(),
});
export type GetLrpQuoteAndPdfParams = z.infer<
  typeof getLrpQuoteAndPdfParamsSchema
>;
